var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamMemberWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 6.47496C14.55 6.46663 14.4917 6.46663 14.4334 6.47496C13.1417 6.43329 12.1167 5.37496 12.1167 4.07496C12.1167 2.74996 13.1917 1.66663 14.525 1.66663C15.85 1.66663 16.9334 2.74163 16.9334 4.07496C16.925 5.37496 15.9 6.43329 14.6084 6.47496Z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3249 12.25C16.3916 12.875 15.0833 13.1083 13.8749 12.95C14.1916 12.2666 14.3583 11.5083 14.3666 10.7083C14.3666 9.87497 14.1833 9.0833 13.8333 8.39164C15.0666 8.22497 16.3749 8.4583 17.3166 9.0833C18.6333 9.94997 18.6333 11.375 17.3249 12.25Z",
    fill: "#F5F6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36672 6.47496C5.42505 6.46663 5.48338 6.46663 5.54172 6.47496C6.83338 6.43329 7.85838 5.37496 7.85838 4.07496C7.85838 2.74163 6.78338 1.66663 5.45005 1.66663C4.12505 1.66663 3.05005 2.74163 3.05005 4.07496C3.05005 5.37496 4.07505 6.43329 5.36672 6.47496Z",
    fill: "#F5F6FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45843 10.7083C5.45843 11.5167 5.63343 12.2833 5.9501 12.975C4.7751 13.1 3.5501 12.85 2.6501 12.2583C1.33343 11.3833 1.33343 9.95834 2.6501 9.08334C3.54176 8.48334 4.8001 8.24167 5.98343 8.37501C5.64176 9.07501 5.45843 9.86667 5.45843 10.7083Z",
    fill: "#F5F6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 13.225C10.0333 13.2167 9.95833 13.2167 9.88333 13.225C8.35 13.175 7.125 11.9167 7.125 10.3667C7.13333 8.78333 8.40833 7.5 10 7.5C11.5833 7.5 12.8667 8.78333 12.8667 10.3667C12.8583 11.9167 11.6417 13.175 10.1 13.225Z",
    fill: "#F5F6FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39175 14.95C6.13341 15.7916 6.13341 17.175 7.39175 18.0083C8.82508 18.9666 11.1751 18.9666 12.6084 18.0083C13.8667 17.1666 13.8667 15.7833 12.6084 14.95C11.1834 13.9916 8.83341 13.9916 7.39175 14.95Z",
    fill: "#F5F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberWhiteIcon);
export default __webpack_public_path__ + "static/media/team-member-white-icon.4be767072a3303ae557df5bcc92c8a41.svg";
export { ForwardRef as ReactComponent };